import { useEffect, useState } from "react";
import { useLazyGetOrganizationPolicies } from "../operations/queries/getOrganizationPolicies";
import {
  MANAGE_CONFIGURATION,
  MANAGE_DOCUMENT_TYPES,
  MANAGE_GANG_MEMBERS,
  MANAGE_LICENCES,
  MANAGE_ORG_ROLES,
  MANAGE_ORG_USERS,
  MANAGE_PROJECTS,
  MANAGE_REFERENCE_PROCEDURES,
  MANAGE_ADMIN_ORG_USERS,
  MANAGE_OPERATOR_ORG_USERS,
  MANAGE_ADMIN_ROLES,
  MANAGE_PROJECT_ASSIGNMENT_CAP,
  MANAGE_PERMIT_TYPES,
  VIEW_ORGANIZATION_DASHBOARD,
} from "../models/Policies";
import { useAppContext } from "./useAppContext";

export function useOrganizationPolicies() {
  const [organizationPolicies, setOrganizationPolicies] = useState<string[]>();
  const { currentOrganization } = useAppContext();
  const { getOrganizationPolicies, data } = useLazyGetOrganizationPolicies();

  useEffect(() => {
    if (currentOrganization) {
      getOrganizationPolicies({ variables: { organizationId: currentOrganization.id } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization]);

  useEffect(() => {
    if (data) {
      setOrganizationPolicies(data.organizationPolicies);
    }
  }, [data]);

  const authorize = (policy: string): boolean => {
    return organizationPolicies ? organizationPolicies.includes(policy) : false;
  };

  const authorizedToManageProjects = authorize(MANAGE_PROJECTS.name);
  const authorizedToManageOrgUsers = authorize(MANAGE_ORG_USERS.name);
  const authorizedToManageGangMembers = authorize(MANAGE_GANG_MEMBERS.name);
  const authorizedToManageDocumentTypes = authorize(MANAGE_DOCUMENT_TYPES.name);
  const authorizedToManageConfiguration = authorize(MANAGE_CONFIGURATION.name);
  const authorizedToManageLicences = authorize(MANAGE_LICENCES.name);
  const authorizedToManageOrgRoles = authorize(MANAGE_ORG_ROLES.name);
  const authorizedToManageReferenceProcedures = authorize(MANAGE_REFERENCE_PROCEDURES.name);
  const authorizedToManageAdminOrgUsers = authorize(MANAGE_ADMIN_ORG_USERS.name);
  const authorizedToManageOperatorOrgUsers = authorize(MANAGE_OPERATOR_ORG_USERS.name);
  const authorizedToManageAdminRoles = authorize(MANAGE_ADMIN_ROLES.name);
  const authorizedToManageProjectAssignmentCap = authorize(MANAGE_PROJECT_ASSIGNMENT_CAP.name);
  const authorizedToManagePermitTypes = authorize(MANAGE_PERMIT_TYPES.name);
  const authorizedToViewOrganizationDashboard = authorize(VIEW_ORGANIZATION_DASHBOARD.name);

  return {
    organizationPolicies,
    authorize,
    authorizedToManageProjects,
    authorizedToManageOrgUsers,
    authorizedToManageGangMembers,
    authorizedToManageDocumentTypes,
    authorizedToManageConfiguration,
    authorizedToManageLicences,
    authorizedToManageOrgRoles,
    authorizedToManageReferenceProcedures,
    authorizedToManageAdminOrgUsers,
    authorizedToManageOperatorOrgUsers,
    authorizedToManageAdminRoles,
    authorizedToManageProjectAssignmentCap,
    authorizedToManagePermitTypes,
    authorizedToViewOrganizationDashboard,
  };
}
